import { Building } from '../../../entities/installation-reporting-mdu-details.entities';
import { BUILDING_REPORT_SECTIONS } from '../model/installation-reporting-mdu-section-layout.config';
import { InstallationReportSectionConfig } from '../model/installation-reporting-mdu-section.types';
import { createBuildingReportSectionState } from './installation-reporting-mdu-section-state.mapper';
import {
  BuildingReportSectionStates,
  SectionState,
} from './installation-reporting-mdu-section-state.types';
import { isSelfInspectionAnswerComplete } from './self-inspection-answer.util';

export const createBuildingReportSectionStates = (
  building: Building,
  sections: InstallationReportSectionConfig[] = BUILDING_REPORT_SECTIONS,
): BuildingReportSectionStates =>
  Object.fromEntries(
    sections.map((section) => [
      section.id,
      createBuildingReportSectionState(section, building),
    ]),
  ) as BuildingReportSectionStates;

export const requiredItemsComplete = (
  config: InstallationReportSectionConfig,
  state: SectionState,
): boolean =>
  config.items
    .filter((item) => item.isRequired)
    .every((item) => state.itemAnswers[item.id]?.completed);

export const completedItemCount = (state: SectionState): number =>
  Object.values(state.itemAnswers).filter(isSelfInspectionAnswerComplete)
    .length;
